// extracted by mini-css-extract-plugin
export default {"wrapper":"AddProjectForm_wrapper__wJnsW","controlWrapper":"AddProjectForm_controlWrapper__oN+Ha"};